import type { ComponentProps, FC } from "react";
import { NavLink, type NavLinkProps } from "react-router";
import { cn } from "../utils";

export const TabsNav: FC<ComponentProps<"nav">> = ({ className, ...props }) => (
  <nav
    className={cn("bg-foreground/7.5 flex h-9 items-stretch justify-center p-0.75 rounded-lg", className)}
    {...props}
  />
);

export const TabsNavLink: FC<NavLinkProps> = ({ className, ...props }) => (
  <NavLink
    className={cn(
      "border border-transparent flex font-medium gap-1.5 items-center justify-center px-2 rounded-md text-foreground text-xs transition-[color,box-shadow] aria-disabled:pointer-events-none aria-disabled:opacity-50",
      "aria-[current]:bg-background aria-[current]:shadow-sm",
      className
    )}
    {...props}
  />
);
